import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kw-layout',
  templateUrl: './kw-layout.component.html',
  styleUrls: ['./kw-layout.component.css']
})
export class KwLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
